export const ANALYTICS_SELECT_ACCOUNT_TYPE =
  'direct-deposit-account/ANALYTICS_SELECT_ACCOUNT_TYPE';

export const ANALYTICS_BANKING_INFO_ACCOUNT_DETAIL =
  'direct-deposit-account/ANALYTICS_BANKING_INFO_ACCOUNT_DETAIL';
